import { render, staticRenderFns } from "./GasNeededDialog.vue?vue&type=template&id=242d622c&scoped=true&"
import script from "./GasNeededDialog.vue?vue&type=script&lang=ts&"
export * from "./GasNeededDialog.vue?vue&type=script&lang=ts&"
import style0 from "./GasNeededDialog.vue?vue&type=style&index=0&id=242d622c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242d622c",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QCardActions,QBtn});
